const bs58 = require('bs58');

// TODO: Import from tf-post-parser instead once it is updated with alwaysConvert!

const imageProxy = (url, width, height, mode, format, alwaysConvert) => {
  if (!url) {
    return undefined;
  }
  if (url.match(/img\.travelfeed\.io/) && !alwaysConvert) return url;
  const isGif = url.substring(url.length - 3, url.length) === 'gif';
  if (
    url.match(
      /(https:\/\/ipfs-3speak\.b-cdn\.net\/ipfs\/)https:\/\/ipfs-3speak\.b-cdn\.net\/ipfs\/(?:.*)/,
    )
  ) {
    url = url.replace(/^https:\/\/ipfs-3speak\.b-cdn\.net\/ipfs\//, '');
  }
  try {
    let imgUrl = url;
    if (imgUrl.match(/images\.hive\.blog/)) {
      const hiveProxyMatch = imgUrl.match(
        /https:\/\/images\.hive\.blog\/p\/([^/]*)/,
      );
      if (isGif) return imgUrl;
      if (hiveProxyMatch && hiveProxyMatch.length > 1) {
        return `https://images.hive.blog/p/${hiveProxyMatch[1]}/?format=${
          format || 'match'
        }${width ? `&width=${width}` : ''}${height ? `&height=${height}` : ''}${
          mode ? `&mode=${mode}` : ''
        }`;
      }
    }

    if (
      !imgUrl.match(/img\.travelfeed\.io/) &&
      !imgUrl.match(/steemitimages\.com/) &&
      !imgUrl.match(/files\.steempeak\.com/) &&
      !imgUrl.match(/files\.peakd\.com/) &&
      !imgUrl.match(/images\.hive\.blog/) &&
      !imgUrl.match(/images\.unsplash\.com/) &&
      !imgUrl.match(/img\.esteem\.app/) &&
      !imgUrl.match(/images\.ecency\.com/) &&
      !imgUrl.match(/ipfs-3speak\.b-cdn\.net/) &&
      !imgUrl.match(/img\.3speakcontent\.co/)
    ) {
      // Steemitimages needs to be used because it has a cache of images deleted from the origin
      // Base58 encode image url
      // https://github.com/steemit/imagehoster
      const bytes = Buffer.from(imgUrl);
      const address = bs58.encode(bytes);
      // Get the cropped steemitimages URL for an image
      imgUrl = `https://steemitimages.com/p/${address}/?format=match&mode=fit`;
    }
    // Base58 encode image url
    // https://github.com/steemit/imagehoster
    const bytes = Buffer.from(imgUrl);
    const address = bs58.encode(bytes);
    // Use webp as format for best compression if supported
    // Get the cropped steemitimages URL for an image
    return `https://images.hive.blog/p/${address}/?format=${format || 'match'}${
      width ? `&width=${width}` : ''
    }${height ? `&height=${height}` : ''}${mode ? `&mode=${mode}` : ''}${
      isGif ? `&type=gif` : ''
    }`;
  } catch (err) {
    console.warn(err);
    return undefined;
  }
};

module.exports = { imageProxy };
